/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { Formik, Form } from 'formik';
import Header from '../../../components/Header';
import Sidebar from '../../../components/Sidebar';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import {
  FormInput,
  RadioButton,
  SingleMultiSelectDropDown,
} from '../../../components/Input/InputText';
import { useDispatch, useSelector } from 'react-redux';
import { GetRoleListAction } from '../../../store/Actions/RolesAction';
import { InputFromUser } from '../../../components/Input/input';
import { AddStaffValidationSchema } from '../../../utils/FormValidation';
import { CreateStaffAction } from '../../../store/Actions/StaffAction';
import { Button } from 'antd';

const AddStaff = () => {
  const dispatch = useDispatch();
  const { RoleList, loader } = useSelector(state => state?.Role);
  useEffect(() => {
    dispatch(GetRoleListAction({ Query: '/get_all_roles' }));
  }, []);
  return (
    <div>
      <Header />
      <Sidebar id="menu-item1" id1="menu-items1" activeClassName="add-staff" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link>Staff</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/staff-list?page=1">Staff List</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Add Staff</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <Formik
                      initialValues={{
                        name: '',
                        phoneNo: '',
                        password: '',
                        confirmPassword: '',
                        dateOfBirth: '',
                        gender: '',
                        status: '',
                        email: '',
                        role: '',
                        orderIndex: '',
                      }}
                      validationSchema={AddStaffValidationSchema}
                      onSubmit={(values, { setErrors, setSubmitting }) => {
                        const filteredData = RoleList?.[0]?.filter(
                          item => item.roleName === values.role
                        );
                        dispatch(
                          CreateStaffAction(
                            {
                              Query: '',
                              obj: {
                                ...values,
                                role: {
                                  roleName: filteredData?.[0]?.roleName,
                                  _id: filteredData?.[0]?.id,
                                },
                              },
                            },
                            Res => {
                              if (Res?.statusCode === 200) {
                                window.location.href = `/staff-list?page=1`;
                              } else if (Res?.statusCode === 400) {
                                window.scrollTo({
                                  top: 0,
                                  behavior: 'smooth',
                                });
                                setErrors(Res?.data?.errors);
                              }
                              setSubmitting(false);
                            }
                          )
                        );
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        setFieldValue,
                        setFieldTouched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setValues,
                        setSubmitting,
                        isSubmitting,
                        /* and other goodies */
                      }) => {
                        return (
                          <Form>
                            <div className="row">
                              <FormInput
                                label="Name"
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.name}
                                touched={touched.name}
                                placeholder="Enter Name"
                                FormGroupClassName="col-xl-6 col-md-12"
                                LabelClassName="col-form-label"
                                FormControlClassName="form-control"
                              />

                              <InputFromUser
                                label="Birthdate"
                                type="date"
                                name="dateOfBirth"
                                value={values.dateOfBirth}
                                onChange={value => setFieldValue('dateOfBirth', value)}
                                onBlur={() => setFieldTouched('dateOfBirth', true)}
                                error={errors.dateOfBirth}
                                touched={touched.dateOfBirth}
                                placeholder="Select Birthdate"
                                FormGroupClassName="col-xl-6 col-md-12"
                                LabelClassName="col-form-label"
                              />

                              <FormInput
                                label="Phone No"
                                name="phoneNo"
                                value={values.phoneNo}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.phoneNo}
                                touched={touched.phoneNo}
                                placeholder="Enter Phone Number"
                                FormGroupClassName="col-xl-6 col-md-12"
                                LabelClassName="col-form-label"
                                FormControlClassName="form-control"
                              />

                              <FormInput
                                label="Email"
                                type="email"
                                name="email"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.email}
                                touched={touched.email}
                                placeholder="Enter Email"
                                FormGroupClassName="col-xl-6 col-md-12"
                                LabelClassName="col-form-label"
                                FormControlClassName="form-control"
                              />

                              <SingleMultiSelectDropDown
                                label="Role"
                                name="role"
                                value={values.role}
                                onChange={v => setFieldValue('role', v)}
                                onBlur={() => setFieldTouched('role', true)}
                                error={errors.role}
                                touched={touched.role}
                                options={RoleList?.[0]?.map(item => item?.roleName) || []}
                                placeholder="Select Role"
                                mode=""
                                Showlabel={true}
                                FormGroupClassName="col-xl-6 col-md-12"
                                LabelClassName="col-form-label"
                              />

                              <InputFromUser
                                label="Password"
                                type="password"
                                name="password"
                                value={values.password}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.password}
                                touched={touched.password}
                                placeholder="Enter Password"
                                FormGroupClassName="col-xl-6 col-md-12"
                                LabelClassName="col-form-label"
                                FormControlClassName="form-control"
                                InputConatiner="position-relative"
                              />

                              <InputFromUser
                                label="Confirm Password"
                                type="password"
                                name="confirmPassword"
                                value={values.confirmPassword}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.confirmPassword}
                                touched={touched.confirmPassword}
                                placeholder="Confirm Password"
                                FormGroupClassName="col-xl-6 col-md-12"
                                LabelClassName="col-form-label"
                                FormControlClassName="form-control"
                                InputConatiner="position-relative"
                              />

                              <RadioButton
                                label="Gender"
                                options={[
                                  { label: 'Male', value: 'Male' },
                                  { label: 'Female', value: 'Female' },
                                ]}
                                selectedValue={values.gender}
                                onChange={v => setFieldValue('gender', v)}
                                onBlur={() => setFieldTouched('gender', true)}
                                error={errors.gender}
                                touched={touched.gender}
                              />

                              <RadioButton
                                label="Status"
                                options={[
                                  { label: 'Active', value: 'active' },
                                  { label: 'Inactive', value: 'inactive' },
                                ]}
                                selectedValue={values.status}
                                onChange={v => setFieldValue('status', v)}
                                onBlur={() => setFieldTouched('status', true)}
                                error={errors.status}
                                touched={touched.status}
                              />

                              <InputFromUser
                                label="Order Index"
                                type="number"
                                name="orderIndex"
                                value={values.orderIndex}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.orderIndex}
                                touched={touched.orderIndex}
                                placeholder="Enter Order Index"
                                FormGroupClassName="col-xl-6 col-md-12"
                                LabelClassName="col-form-label"
                                FormControlClassName="form-control"
                              />

                              <div className="col-12 mt-5">
                                <div className="text-end">
                                  <Button
                                    onClick={() => {
                                      handleSubmit();
                                    }}
                                    type="primary"
                                    disabled={isSubmitting}
                                    className="me-2"
                                  >
                                    Submit
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default AddStaff;
